import { StyleSheet } from 'aphrodite';
import { brandPrimaryText } from '../../../../web/styles/colors';

export const styleSheet = StyleSheet.create({
	container: {
		background: '#F3CE0D',
		borderRadius: 10,
		boxShadow: '0px 0px 6px rgba(139, 139, 139, 0.1)',
		cursor: 'pointer',
		height: 106,
		marginTop: 30,
	},
	text: {
		color: brandPrimaryText,
		fontSize: 18,
		fontWeight: 800,
		letterSpacing: 1.8,
		padding: 30,
		textDecoration: 'underline',
		textTransform: 'uppercase',
	},
});
